import { Component, element as $, elements as $$ } from '@contorion/core';

const CLASS_HIDDEN = 'hidden';
const SELECTOR_ITEMS = '.js-breadcrumbs-item';
const SELECTOR_BACK = '.js-breadcrumbs-back';
const SELECTOR_EXPANDER = '.js-breadcrumbs-expander';

export class BreadcrumbsComponent extends Component {
    protected get items(): Array<Element> {
        return $$(SELECTOR_ITEMS, this.element);
    }

    protected get back(): Element {
        return $(SELECTOR_BACK, this.element);
    }

    protected get expander(): Element {
        return $(SELECTOR_EXPANDER, this.element);
    }

    constructor(protected element: Element) {
        super(element);

        if (this.back && window.history.length < 2) {
            this.back.remove();
        } else if (this.back) {
            this.back.addEventListener('click', this.onBackClick.bind(this));
        }

        if (this.expander) {
            this.expander.addEventListener('click', this.onExpanderClick.bind(this));
        }
    }

    protected expand(): void {
        for (const item of this.items) {
            item.classList.remove(CLASS_HIDDEN);
        }

        this.expander.parentElement.remove();
    }

    protected onBackClick(e: Event): void {
        e.preventDefault();

        window.location.href = document.referrer;
    }

    protected onExpanderClick(e: Event): void {
        e.preventDefault();

        this.expand();
    }
}
